import { render, staticRenderFns } from "./rk-icon.vue?vue&type=template&id=15ec49b3&"
import script from "./rk-icon.vue?vue&type=script&lang=ts&"
export * from "./rk-icon.vue?vue&type=script&lang=ts&"
import style0 from "./rk-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports